import { Fields } from "../BlankCanvasDetailsStep/BlankCanvasDetailsStep.styles";

/**
 * Figma 5326:88134 / 5326:88970 — the fields stack with the same 12px gutter
 * the blank-canvas frame uses, so the stack is imported rather than
 * re-declared. Re-exported under this name so the body reads against its own
 * module and the frames cannot drift apart on the gutter.
 */
export const Sections = Fields;
